<template>
    <el-select v-model="data" @change="dataChange" value-key="Key"  size="small" :clearable="clearable" @clear='dataChange'
        style="width:100%;" :disabled='disabled'>
        <el-option v-for="item in datas" :key="item.Key" :label="item.Name" :value="item">
            <div class="proItem">
                <div class="name">{{ item.Name }}</div>
                <div class="companys">
                    <div class="company">
                        {{ item.Code }}
                    </div>
                </div>
            </div>
        </el-option>
    </el-select>
</template>
<script>
import { getAll } from "@/api/product/productType";
export default {
    model: {
        prop: "value",
        event: "change",
    },
    props: {
        value: {
            default: ""
        },
        clearable: {
            default: true
        },
        disabled: {
            default: false
        },
    },
    data() {
        return {
            datas: [],
            data: ''
        }
    },
    watch: {
        value: {
            handler(v) {
                this.data = v
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getData() {
            let param = {
                search: "",
            }
            getAll(param).then(res => {
                if (res) {
                    this.datas = res.Items;
                }
            })
        },
        dataChange(v) {
            this.$emit("change", v)
        }
    },
    mounted() {
        this.getData()
    }
}
</script>
<style>
.el-select-dropdown__item {
    height: auto !important;
}
</style>
<style lang='scss' scoped>
.proItem {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .name {}

    .companys {
        display: flex;
        justify-content: center;
        flex-direction: column;

        .company {
            font-size: 10px;
            line-height: 16px;
            color: silver;
            margin-bottom: 10px;
            font-weight: normal;
        }
    }
}
</style>